import React from 'react'
import LineSvg from '../../Components/SVG/LineSvg'
import Skills from './Skills'
import Certifications from './Certifications'

const About = () => {
  return (
    <div className='w-full h-full flex justify-center'>
      <div className='text-center w-full mx-w-[60vw] text-secondary mb-36'>
        <div className="relative mt-10">
          <LineSvg className={`left-0 right-0 -top-10 m-auto absolute w-[10em]`} />
          <p className=' text-xl font-bold underline'>Intro</p>
          <p className='text-secondary container m-auto md:max-w-[90%] lg:max-w-[60%]'>
            I am a Developer with a keen interest in both front-end, back-end, and DevOp technologies. I
            love listening to pop music, playing chess, and reading manga. I am always curious to learn more.
          </p>
          <LineSvg className={`left-0 right-0 m-auto -bottom-10 absolute w-[10em] rotate-180`} />
        </div>

        <Skills />

        {/* <Certifications />

        <div className="relative mt-36">
          <LineSvg className={`left-0 right-0 -top-10 m-auto absolute w-[10em]`} />
          <p className=' text-xl font-bold underline'>Awards</p>
          <p className='text-secondary container m-auto md:max-w-[90%] lg:max-w-[60%]'>
            I am a Developer with a keen interest in both front-end, back-end, and DevOp technologies. I
            love listening to pop music, playing chess, and reading manga. I am always curious to learn more.
          </p>
          <LineSvg className={`left-0 right-0 m-auto -bottom-10 absolute w-[10em] rotate-180`} />
        </div>


        <div className="relative mt-36">
          <LineSvg className={`left-0 right-0 -top-10 m-auto absolute w-[10em]`} />
          <p className=' text-xl font-bold underline'>Awards</p>
          <p className='text-secondary container m-auto md:max-w-[90%] lg:max-w-[60%]'>
            I am a Developer with a keen interest in both front-end, back-end, and DevOp technologies. I
            love listening to pop music, playing chess, and reading manga. I am always curious to learn more.
          </p>
          <LineSvg className={`left-0 right-0 m-auto -bottom-10 absolute w-[10em] rotate-180`} />
        </div>
        <div className="relative mt-10">&nbsp;</div> */}
      </div>
    </div>
  )
}

export default About
